import { SegmentFilters, SegmentFiltersAdmin } from '../../../models/segments';

type Action =
  | { type: 'clearAll'; defaultFilters: SegmentFilters | SegmentFiltersAdmin }
  | { type: 'cancel' }
  | { type: 'apply' }
  | { type: 'setFilters'; filters: Partial<SegmentFilters | SegmentFiltersAdmin> };

type State = {
  filters: SegmentFilters | SegmentFiltersAdmin;
  previousFilters: SegmentFilters | SegmentFiltersAdmin;
  filterCount: number;
};

function calculateAppliedCount(appliedFilters: SegmentFilters | SegmentFiltersAdmin) {
  const activeDates = Number(appliedFilters.startDate !== null) + Number(appliedFilters.endDate !== null);
  const activeCustomers = Number(appliedFilters.min !== '') + Number(appliedFilters.max !== '');
  return (
    activeDates +
    activeCustomers +
    appliedFilters.isShared.length +
    ('teams' in appliedFilters && appliedFilters.teams.length) +
    appliedFilters.users.length
  );
}

export function segmentsFilterReducer(state: State, action: Action) {
  switch (action.type) {
    case 'setFilters': {
      return {
        ...state,
        filters: { ...state.filters, ...action.filters }
      };
    }
    case 'cancel': {
      return {
        ...state,
        filters: state.previousFilters,
        filterCount: calculateAppliedCount(state.previousFilters)
      };
    }
    case 'clearAll': {
      return {
        filters: action.defaultFilters,
        previousFilters: action.defaultFilters,
        filterCount: 0
      };
    }
    case 'apply': {
      return {
        ...state,
        previousFilters: state.filters,
        filterCount: calculateAppliedCount(state.filters)
      };
    }
  }
}
